import 'whatwg-fetch';
import store from '../../store';

const API_BASE_URL = 'https://cdn.contentful.com';
const API_SPACE_ID = '74e5dqn7tded';
const API_TOKEN = '0c944c3077d82465ce5a39d6110dd4eeadece8c8f5e4295658bfca138e87d241';

const LocaleMap = {
    en: 'en-US',
    sv: 'sv'
};

const checkStatus = (response) => {
    // Check status on response. Raise error if not success
    if (response.status >= 200 && response.status < 300) {
        return response;
    }

    let error = new Error(response.statusText);

    error.response = response;
    throw error;
};


const parseResponse = (response) => {
    return response.json();
};

const getLocaleFromStore = () => {
    const defaultLanguage = 'en';
    const languageProvider = store.getState().languageProvider;

    return languageProvider.locale ? languageProvider.locale : defaultLanguage;
};

export const getDataContentful = (contentType = null) => {
    // Get locale from global state
    const locale = getLocaleFromStore();

    // Change format according to Contentful
    const contentfulLocale = LocaleMap[locale];

    let url = `${API_BASE_URL}/spaces/${API_SPACE_ID}/entries?access_token=${API_TOKEN}&locale=${contentfulLocale}`;

    if (contentType) {
        url += `&content_type=${contentType}`;
    }

    return fetch(url)
        .then(checkStatus)
        .then(parseResponse);
};

export const getContentfulEntry = (entryId, locale = null) => {
    if (!locale) {
        locale = getLocaleFromStore();
    }

    // Change format according to Contentful
    const contentfulLocale = LocaleMap[locale];

    const url = `${API_BASE_URL}/spaces/${API_SPACE_ID}/entries/${entryId}?access_token=${API_TOKEN}&locale=${contentfulLocale}`;

    return fetch(url)
        .then(checkStatus)
        .then(parseResponse);
};
